// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"ComboBox__dropdown","div-position":"ComboBox__div-position","divPosition":"ComboBox__div-position","close-position":"ComboBox__close-position","closePosition":"ComboBox__close-position","result-not-found":"ComboBox__result-not-found","resultNotFound":"ComboBox__result-not-found","show-all-result":"ComboBox__show-all-result","showAllResult":"ComboBox__show-all-result"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ComboBox/ComboBox.scss
// module id = 1763
// module chunks = 8